import { render, staticRenderFns } from "./DigitalMentalHealthLanding.vue?vue&type=template&id=bb40ece4"
import script from "./DigitalMentalHealthLanding.vue?vue&type=script&lang=js"
export * from "./DigitalMentalHealthLanding.vue?vue&type=script&lang=js"
import style0 from "./DigitalMentalHealthLanding.vue?vue&type=style&index=0&id=bb40ece4&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports